<div class="modal-header">
  <h4 class="modal-title">Check-In Details</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body" *ngIf="isLoading()">
  <div class="alert alert-info">Loading...</div>
</div>

<div class="modal-body" *ngIf="serverError">
  <div class="alert alert-danger">Server error: {{ serverError }}</div>
</div>

<div class="modal-body" *ngIf="checkIn && !isLoading() && !serverError">

  <p>
    <b>Check-In Time</b>
    <br>
    {{ dateStringFromISO8601(checkIn.check_in_datetime) }}, {{ timeStringFromISO8601(checkIn.check_in_datetime) }}
  </p>

  <p>
    <b>Check-Out Time</b>
    <br>
    <span *ngIf="checkIn.check_out_datetime">
      {{ dateStringFromISO8601(checkIn.check_out_datetime) }}, {{ timeStringFromISO8601(checkIn.check_out_datetime) }}
      (duration {{ checkIn.visit_duration_minutes }} minutes)
    </span>
    <span *ngIf="!checkIn.check_out_datetime" class="text-success">Active</span>
  </p>

  <p>
    <b>Location</b>
    <ng-container *ngIf="!editingCheckInLocation">
      |
      <a href="#"
         (click)="$event.preventDefault();editingCheckInLocation = true;">
        Edit
      </a>
      <br>
      {{ checkIn.location_name }}
    </ng-container>
    <ng-container *ngIf="editingCheckInLocation">
      <br>
      <select class="custom-select custom-select-sm mb-1 mt-1" name="selectedLocationId"
              [disabled]="loadingEditLocation" [class.disabled]="loadingEditLocation"
              [(ngModel)]="selectedLocationId">
        <option *ngFor="let location of locationService.getLocations()"
                [ngValue]="location.id">
          {{ location.name }}
        </option>
      </select>
      <br>
      <button class="btn btn-primary btn-sm mr-1" type="button"
              [disabled]="loadingEditLocation" [class.disabled]="loadingEditLocation"
              (click)="handleEditLocation();">
        {{ loadingEditLocation ? 'Loading...' : 'Save' }}
      </button>
      <button class="btn btn-secondary btn-sm" type="button"
              [disabled]="loadingEditLocation" [class.disabled]="loadingEditLocation"
              (click)="editingCheckInLocation = false;">
        Cancel
      </button>
    </ng-container>
  </p>

  <p>
    <b>Entry Method Type</b>
    <br>
    {{ getCheckInEntryMethodDisplay(checkIn.entry_method) }}
    <span *ngIf="checkIn.converted_from_free_entry">
      (converted from Free Entry)
    </span>
  </p>

  <p>
    <b>Entry Method</b>
    <br>
    {{ checkIn.entry_method_description }}
  </p>

  <p *ngIf="checkIn.converted_from_free_entry">
    <b>Free Entry Originally Granted By</b>
    <br>
    {{ checkIn.free_entry_granting_user_first_name }}
    {{ checkIn.free_entry_granting_user_last_name }}
  </p>

  <p *ngIf="(checkIn.entry_method === CheckInEntryMethod.freeEntry) || checkIn.converted_from_free_entry">
    <b>Free Entry Notes</b>
    <br>
    <span *ngIf="checkIn.free_entry_reason">{{ checkIn.free_entry_reason }}</span>
    <span *ngIf="!checkIn.free_entry_reason" class="text-secondary">None</span>
  </p>

  <p>
    <b>Milestones</b>
    <br>
    <ng-container *ngFor="let milestone of checkIn.milestone_list; let last = last;">
      <span class="text-primary">{{ milestone }}</span>
      <br *ngIf="!last">
    </ng-container>
    <span *ngIf="checkIn.milestone_list.length === 0" class="text-muted">
      None
    </span>
  </p>

  <div class="alert alert-success mt-5" *ngIf="successMessage">{{ successMessage }}</div>

  <div class="alert alert-danger mt-5" *ngIf="errorMessage">{{ errorMessage }}</div>

  <button class="btn btn-block btn-primary mt-5"
          *ngIf="checkIn.entry_method === CheckInEntryMethod.freeEntry"
          (click)="handleConvertToPaidEntry(false)">
    Convert To Paid Entry
  </button>

</div>
